import { Modal } from 'antd';
import Button from '../../../../components/button/Button';
import { FieldKeys } from '../../../../common/api/services/HistoryApi/types/fieldKeys';
interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    tabName: string;
    selectedDelete: any;
    activeFieldsItems: any;
    historyFieldItems: any;
}

const DeleteHistoryModal = (props: IProps) => {
    const { isOpen, onClose, tabName, onSubmit, selectedDelete, activeFieldsItems, historyFieldItems } = props;

    const getDeleteText = () => {
        const isAddressTab = ['Abroad address', 'Swiss address'].includes(tabName as FieldKeys);
        const sourceList = selectedDelete?.isActive ? activeFieldsItems : historyFieldItems;
        const taxItems = sourceList[selectedDelete?.index]?.taxItems || [];
        const hasCantonScale = taxItems.some((item: any) => item?.taxScale || item?.cantonIS);
        if (isAddressTab && hasCantonScale) {
            return 'Are you sure you want to delete this address? It will affect the information on the Tax-at-source.';
        }

        return `Are you sure you want to delete this ${tabName?.toLowerCase() || ''}?`;
    };

    return (
        <Modal
            open={isOpen}
            centered
            footer={null}
            onCancel={onClose}
            wrapClassName="footer-edit-lead-modal-window-wrapper"
        >
            <div className="send-modal-container">
                <span style={{ fontSize: '18px' }}>{getDeleteText()}</span>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '1rem',
                    }}
                >
                    <Button buttonWidth={'200px'} buttonSize="normal" buttonStyle="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button buttonWidth={'200px'} buttonSize="normal" buttonStyle="primary" onClick={onSubmit}>
                        Confirm
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteHistoryModal;
